<template>
  <NiceView :title="$gettext('No organizations')" icon="icon-business-unit">
    <p class="mt-0 mb-4" v-translate>
      Your account is not linked to any organizations. Contact <a href="mailto:info@olaii.com">info@olaii.com</a> to assign a organization to your
      account.
    </p>

    <div class="buttons">
      <a class="btn btn-primary" href="/" v-translate>Back to safety</a>
      <button class="btn btn-danger" @click="authStore.logout()">
        <span v-translate>Logout</span>
        <span class="ml-1" v-if="profile">({{ profile.email }})</span>
      </button>
    </div>
  </NiceView>
</template>

<script setup>
import { useAuthStore } from "@/store/auth.store";
import { computed, onBeforeMount } from "vue";
const authStore = useAuthStore();
const profile = computed(() => authStore.userProfile);

onBeforeMount(async () => {
  // Fetch user profile
  await authStore.getUserProfile();
});
</script>
